import AssetKpiRow from "./AssetKpiRow";

const EMPTY_COPY = {
  "with-assets": {
    title: "No location-specific assets yet",
    hint: "Switch to By KPI, expand a KPI and click Add to create assets.",
  },
  "with-sub-kpis": {
    title: "No global assets yet",
    hint: "Switch to By KPI, expand a KPI and click Add to create global assets.",
  },
  default: {
    title: "No assets match this filter",
    hint: "Try adjusting your search or filter.",
  },
};

/** Asset list (inverse of KpiList): header, rows, empty state. */
export default function AssetList({
  displayGroups,
  kpiView,
  allQuestions,
  kpiAssetMap,
  sources,
  selectedFYId,
  onSaved,
  isViewOnly,
  canCreate,
  canUpdate,
  canDelete,
}) {
  if (displayGroups.length === 0) {
    const copy = EMPTY_COPY[kpiView] || EMPTY_COPY.default;
    return (
      <div className="kpa-empty-state">
        <div style={{ fontSize: 32, marginBottom: 10, opacity: 0.3 }} aria-hidden="true">🏭</div>
        <div style={{ fontSize: 13, fontWeight: 600, color: "var(--kpa-slate-400)", marginBottom: 6 }}>{copy.title}</div>
        <div style={{ fontSize: 12, color: "var(--kpa-slate-300)" }}>{copy.hint}</div>
      </div>
    );
  }

  return (
    <>
      <div className="kpa-list-header">
        <span className="kpa-list-header-label">Asset Title</span>
        <span style={{ fontSize: 10, color: "var(--kpa-slate-400)" }}>
          {displayGroups.length} asset{displayGroups.length !== 1 ? "s" : ""}
        </span>
      </div>
      <div style={{ maxHeight: 620, overflowY: "auto" }}>
        {displayGroups.map((group, idx) => (
          <AssetKpiRow
            key={group.key}
            group={group}
            allQuestions={allQuestions}
            sources={sources}
            kpiAssetMap={kpiAssetMap}
            selectedFYId={selectedFYId}
            onSaved={onSaved}
            disabled={isViewOnly}
            isLast={idx === displayGroups.length - 1}
            canCreate={canCreate}
            canUpdate={canUpdate}
            canDelete={canDelete}
          />
        ))}
      </div>
    </>
  );
}
